import React, { useEffect, useRef } from 'react';

import LineChart from '@/pages/dashboard/components/Chart/components/LineChart';
import type { ChartRef, LineChartProps } from '@/pages/dashboard/components/Chart/_config/interface';

/**
 * 竞品趋势：父级仅改变 chart-box 的 height（如 Segment 联动、切语言）时，
 * 需对 echarts 实例 resize；逻辑只放在 competitor，不修改公共 LineChart。
 */
const ResizeAwareLineChart = (props: LineChartProps) => {
  const chartRef = useRef<ChartRef>(null);
  const { height } = props;

  useEffect(() => {
    if (height === undefined) {
      return;
    }
    const inst = chartRef.current?.instance();
    if (!inst) {
      return;
    }
    inst.resize({ animation: { duration: 300 } });
    const id = requestAnimationFrame(() => {
      inst.resize({ animation: { duration: 300 } });
    });
    return () => cancelAnimationFrame(id);
  }, [height]);

  return <LineChart ref={chartRef} {...props} />;
};

export default ResizeAwareLineChart;
